import { Checkbox, Input, InputNumber, message, Modal, Select } from 'antd';
import axiosInstance from '../../../../../axios/axiosInstance';
import React, { useEffect, useState } from 'react';
import { useMasterGradesSelector, useMasterSubjectsSelector } from '../../../../../redux/selector';
import { ModePage } from 'common/enum';
import processError from '../../../../../utils/processError';
import { SkillTypeRequest } from '../../../../../model/request';

interface Props {
  isOpen: boolean;
  onCloseModal: () => void;
  modePage: ModePage;
  onBeforeSuccess: () => void;
  skillTypeId: string;
}

export default function AddNewSkillType({ isOpen, onCloseModal, modePage, onBeforeSuccess, skillTypeId }: Props) {
  const [newSkillType, setSkillType] = useState<SkillTypeRequest | null>(null);
  const gradeList = useMasterGradesSelector();
  const subjectList = useMasterSubjectsSelector();

  const onInputField = (e: any, fieldName: string) => {
    const newExerciseFormatTemp = { ...newSkillType } as any;
    newExerciseFormatTemp[fieldName] = e.target.value;

    setSkillType(newExerciseFormatTemp);
  };

  const onCheckboxField = (e: any, fieldName: string) => {
    const newSkillTypeTemp = { ...newSkillType } as any;
    newSkillTypeTemp[fieldName] = e.target.checked;

    setSkillType(newSkillTypeTemp);
  };

  const onChangeSelect = (e: any, fieldName: string) => {
    const newExerciseFormatTemp = { ...newSkillType } as any;
    newExerciseFormatTemp[fieldName] = {
      id: e,
    };

    setSkillType(newExerciseFormatTemp);
  };

  const loadNewSkillType = async () => {
    setSkillType({
      id: '',
      name: '',
      code: '',
      questionCount: 0,
      webViewActive: true,
      webViewOrder: 1,
    });
  };

  const loadEditSkillType = async () => {
    try {
      const res = await axiosInstance({
        url: `/skill-types/${skillTypeId}`,
        method: 'get',
      });

      if (res.status === 200) {
        setSkillType(res.data);
      } else {
        message.error('Có lỗi xảy ra.');
      }
    } catch (err) {
      processError(err);
    }
  };

  const onOk = async () => {
    if (!newSkillType) {
      return;
    }
    if (!newSkillType.name) {
      message.error('Vui lòng nhập tên dạng năng lực').then();
      return;
    }
    if (!newSkillType.subject) {
      message.error('Vui lòng chọn môn học').then();
      return;
    }
    try {
      await axiosInstance({
        url: '/skill-types',
        method: modePage === ModePage.ADD ? 'post' : 'put',
        data: newSkillType,
      });
      message.success(modePage === ModePage.ADD ? 'Thêm thành công.' : 'Sửa thành công.');
      onBeforeSuccess();
    } catch (err) {
      processError(err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      modePage === ModePage.ADD ? loadNewSkillType() : loadEditSkillType();
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} onOk={onOk} onCancel={onCloseModal}>
      <div className="mt-8">
        <div className="flex items-center gap-2">
          <div className="w-[210px]">
            Tên dạng năng lực: <span className={'text-FF1D30'}>*</span>
          </div>
          <Input
            maxLength={255}
            name="name"
            onChange={(e) => onInputField(e, 'name')}
            value={newSkillType?.name}
            required
          />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Mã dạng năng lực:</div>
          <Input maxLength={255} name="code" onChange={(e) => onInputField(e, 'code')} value={newSkillType?.code} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[140px]">
            Môn học: <span className={'text-FF1D30'}>*</span>
          </div>
          <Select
            onChange={(e) => onChangeSelect(e, 'subject')}
            className="w-full"
            style={{ flex: 1 }}
            value={newSkillType && newSkillType.subject ? newSkillType.subject.id : ''}
            options={subjectList.map((item: any) => ({
              value: item.id,
              label: item.name,
            }))}
          />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[140px]">Lớp:</div>
          <Select
            onChange={(e) => onChangeSelect(e, 'grade')}
            className="w-full"
            style={{ flex: 1 }}
            value={newSkillType && newSkillType.grade ? newSkillType.grade.id : ''}
            options={gradeList.map((item: any) => ({
              value: item.id,
              label: item.name,
            }))}
          />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Số câu hỏi:</div>
          <Input
            type="number"
            name="questionCount"
            onChange={(e) => onInputField(e, 'questionCount')}
            value={newSkillType?.questionCount}
          />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>Hiển thị trên web</label> <br />
          <Checkbox checked={newSkillType?.webViewActive} onChange={(e) => onCheckboxField(e, 'webViewActive')} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>
            Độ ưu tiên hiển thị <span className={'text-FF1D30'}>*</span>
          </label>{' '}
          <br />
          <InputNumber
            placeholder="Nhập độ ưu tiên hiển thị..."
            value={newSkillType?.webViewOrder}
            onChange={(e) =>
              newSkillType &&
              setSkillType({
                ...newSkillType,
                webViewOrder: e || 1,
              })
            }
            required
          />
        </div>
      </div>
    </Modal>
  );
}
